import {
  BOOKINGCALENDAR
} from '../../reduxs'

const initialState = {
  list: null,
  allListEvent: null,
  allListEventSideBar: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case BOOKINGCALENDAR.actionType.SAVE_LIST_BOOKING_CAR:
      return {
        ...state, list: action.list
      }
    case BOOKINGCALENDAR.actionType.CLEAR_LIST_BOOKING_CAR:
      return {
        ...state, list: initialState.list
      }
    case BOOKINGCALENDAR.actionType.SAVE_ALL_LIST_EVENT:
      return {
        ...state, allListEvent: action.data
      }
    case BOOKINGCALENDAR.actionType.SAVE_ALL_LIST_EVENT_SIDE_BAR:
      return {
        ...state, allListEventSideBar: action.data
      }
    case BOOKINGCALENDAR.actionType.CLEAR_ALL_LIST_EVENT:
      return {
        ...state, allListEvent: null
      }
    case BOOKINGCALENDAR.actionType.CLEAR_ALL_LIST_EVENT_SIDE_BAR:
      return {
        ...state, allListEventSideBar: null
      }

    default:
      return state
  }
}
